import * as React from "react";
const SvgButtonShare = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "Share-1--Streamline-Streamline-3.0",
	height: 24,
	width: 24,
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Share 1 Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("title", null, "share-1"), /* @__PURE__ */ React.createElement("path", {
	d: "M17.25 8.25h1.5a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1 -1.5 1.5H5.25a1.5 1.5 0 0 1 -1.5 -1.5v-12a1.5 1.5 0 0 1 1.5 -1.5h1.5",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m12 0.75 0 10.5",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.25 4.5 12 0.75l3.75 3.75",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}));
export { SvgButtonShare as ReactComponent };
